
/**
 * A wrapper around the native fetch to bypass Service Worker interception
 * for critical Supabase Auth requests.
 */
export const bypassFetch = async (input, init = {}) => {
    let url = input;
    let options = { ...init };

    // Handle Request object input
    if (input instanceof Request) {
        url = input.url;
        // Merge options carefully
        // Note: Body streams are consumed if we read them, but Request usually has bodyUsed false here.
        // However, Supabase JS typically passes string URL and JSON body in init.
        // We assume string input for simplicity as per Supabase client internals.
    }

    let urlStr = url.toString();

    // Check if target is Supabase Auth
    // We look for '/auth/v1/' in the path
    if (urlStr.includes('/auth/v1/')) {
        // console.log(`[BypassFetch] Enhancing Auth Request: ${urlStr}`);

        try {
            // Handle relative URLs by using current origin
            const baseUrl = (urlStr.startsWith('http') || urlStr.startsWith('//'))
                ? undefined
                : window.location.origin;

            const urlObj = new URL(urlStr, baseUrl);

            // 1. Query Param Bypass (for Workbox routing)
            urlObj.searchParams.set('_sw_bypass', 'true');

            // Convert back to string (relative if it was relative? No, URL object makes it absolute)
            // Supabase client handles absolute URLs fine.
            url = urlObj.toString();

        } catch (e) {
            console.warn("[BypassFetch] Failed to parse URL:", urlStr, e);
        }

        // 2. Duplex Bypass (Chrome-specific "Hack")
        // Only effective if body is a ReadableStream, but harmless otherwise.
        // We add it just in case Supabase sends streams or browser behavior changes.
        if (options.method && ['POST', 'PUT', 'PATCH'].includes(options.method.toUpperCase())) {
            options.duplex = 'half';
        }

        // 3. Cache control
        options.cache = 'no-store';
    }

    // [NEW] Handle Edge Function Cookies (fast_cookie)
    // We must force credentials='include' so the browser sends the HttpOnly cookie
    // to the cross-site Supabase Function.
    if (urlStr.includes('fast_cookie')) {
        // console.log("[BypassFetch] Attaching credentials to fast_cookie request");
        options.credentials = 'include';
    }

    return fetch(url, options);
};
